import classnames from 'classnames';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import { useAppDispatch } from '../../../hooks/react-redux';
import { toggleUploadModal } from '../../documents/my-documents/store';
import { Icon } from '../../shared/icon/Icon';
import { CustomTooltip } from '../../shared/tooltip';
import styles from './Modules.module.scss';

interface HomeButtonProps {
    label: string;
    icon: React.FC;
    disabled?: boolean;
    onClick?: () => void;
    path?: string;
    testId?: string;
    fill?: string;
    iconSize?: number;
    isAdminModule?: boolean;
    disabledTooltip?: string;
}

const HomeButton: React.FC<HomeButtonProps> = ({ label, icon, disabled = false, onClick, path, testId, fill, iconSize, isAdminModule = false, disabledTooltip = null }) => {
    const [isHovering, setIsHovering] = useState<boolean>(false);
    const showLabel = useCallback(() => setIsHovering(true), [setIsHovering]);
    const hideLabel = useCallback(() => setIsHovering(false), [setIsHovering]);

    if (path && !disabled) {
        return (
            <Link className={styles.linkButton} to={path} style={{ width: `calc(${100 / (isAdminModule ? 3 : 2)}% - 10px)` }}>
                <button
                    className={styles.homeButton}
                    onClick={onClick}
                    data-testid={`home-button-${testId}`}
                    onMouseOver={showLabel}
                    onMouseOut={hideLabel}
                    style={{ height: `${(iconSize || 0) * 1.5}px` }}
                >
                    <div className={styles.homeButtonIcon}>
                        <Icon icon={icon} fontSize={iconSize} fill={fill} />
                    </div>
                    {isHovering && <div className={classnames(styles.homeButtonLabel, { [styles.disabledHomeButtonLabel]: disabled })}>{label}</div>}
                </button>
            </Link>
        );
    }
    return (
        <div className={styles.linkButton} style={{ width: `calc(${100 / (isAdminModule ? 3 : 2)}% - 10px)` }}>
            <CustomTooltip overlayText={disabledTooltip} placement='top'>
                <button
                    className={classnames(styles.homeButton, { [styles.disabledHomeButton]: disabled })}
                    onClick={onClick}
                    data-testid={`home-button-${testId}`}
                    onMouseOver={showLabel}
                    onMouseOut={hideLabel}
                    style={{ height: `${(iconSize || 0) * 1.5}px` }}
                >
                    <div className={styles.homeButtonIcon}>
                        <Icon icon={icon} fontSize={iconSize} fill={fill} />
                    </div>
                    {isHovering && <div className={classnames(styles.homeButtonLabel, { [styles.disabledHomeButtonLabel]: disabled })}>{label}</div>}
                </button>
            </CustomTooltip>
        </div>
    );
};

interface DocumentHomeButtonProps {
    disabled?: boolean;
    label: string;
    icon: React.FC;
    testId: string;
    path?: string;
    fill?: string;
    onDisabledClick?: () => void;
    iconSize?: number;
    disabledTooltip?: string;
}

export const HomeButtonTileAdd: React.FC<DocumentHomeButtonProps> = ({ disabled, onDisabledClick, label, icon, testId, iconSize, disabledTooltip }) => {
    const dispatch = useAppDispatch();
    const onClick = useCallback(() => disabled ? onDisabledClick : dispatch(toggleUploadModal(true)), [disabled, onDisabledClick, dispatch]);
    return (
        <HomeButton label={label} icon={icon} onClick={onClick} testId={testId} disabled={disabled} iconSize={iconSize} disabledTooltip={disabledTooltip} />
    );
};

export const HomeButtonTile: React.FC<DocumentHomeButtonProps> = ({ disabled, onDisabledClick, path, label, icon, testId, fill, iconSize, disabledTooltip }) => <HomeButton path={path} label={label} icon={icon} testId={testId} fill={fill} disabled={disabled} onClick={onDisabledClick} iconSize={iconSize} isAdminModule={path?.includes('admin')} disabledTooltip={disabledTooltip} />;
